const footerLinks = [
  {
    title: '电影分类',
    links: [
      { label: '动作大片', href: '#cards' },
      { label: '喜剧电影', href: '#cards' },
      { label: '科幻巨制', href: '#cards' },
      { label: '爱情文艺', href: '#cards' },
    ],
  },
  {
    title: '快捷导航',
    links: [
      { label: '热门话题', href: '#topics' },
      { label: '精选专题', href: '#carousel' },
      { label: '最新快讯', href: '#updates' },
      { label: '热映榜单', href: '#ranking' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
      { label: '关于我们', href: '#about' },
      { label: '主题索引', href: '#index' },
    ],
  },
];

const partnerPlaceholders = [
  '电影资讯网',
  '影视推荐平台',
  '在线电影导航',
  '影评交流社区',
  '电影资料库',
  '影视周刊',
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold text-white font-heading">小草影院</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4 max-w-sm">
              小草影院汇集院线大片、最新上映电影及动作片、喜剧电影等分类大全。片库每日更新，高清在线观看各类影片，快速找到你想看的电影。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-300 text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-300 text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-background-300 text-sm"></i>
              </div>
            </div>
          </div>

          {footerLinks.map((group, i) => (
            <div key={i}>
              <h3 className="text-sm font-semibold text-white mb-4 font-heading">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.links.map((link, j) => (
                  <li key={j}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavClick(link.href);
                      }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-800">
          <p className="text-xs text-background-500 mb-4">
            <strong className="text-background-400">合作伙伴</strong>
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {partnerPlaceholders.map((name, i) => (
              <span key={i} className="text-xs text-background-600 whitespace-nowrap">
                {name}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-600 whitespace-nowrap">
            &copy; 2024-2026 小草影院 xiaocaocinema.com 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-600 cursor-pointer hover:text-background-400 transition-colors whitespace-nowrap">
              隐私政策
            </span>
            <span className="text-xs text-background-600 cursor-pointer hover:text-background-400 transition-colors whitespace-nowrap">
              使用条款
            </span>
            <span className="text-xs text-background-600 cursor-pointer hover:text-background-400 transition-colors whitespace-nowrap">
              免责声明
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}